export default __webpack_public_path__ + "74742a81756bec4b353eb96d1447e2df.jpg";